module.exports = __webpack_public_path__ + "img/50-50.deb66aa9.svg";